export default __webpack_public_path__ + "static/media/facebook.a9d43e96.svg";